import React, { useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import { useQuery, useQueryClient } from 'react-query';
import { getScheduleMainGrid } from "data/Querys";
import { groupByDate } from "helpers/utils";
import { dateFormat } from "helpers/utils";
import { useViewport } from 'components/general/useViewPort';
import { getURL, isValidDate } from 'helpers/utils';
import Moment from 'react-moment';
import moment from 'moment';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import NotAvailable from "components/common/NotAvailable";
import Loader from 'components/general/Loader';
import MirsTable from "components/general/table/Table";
import Label from "components/general/Label";
import Discipline from "components/presentation/Discipline";
import PageHeader from "components/common/PageHeader";
import { useGetURL } from "helpers/urlFriendly";


function ScheduleGrid() {

  let params = useParams();
  //Copy object in order to change 
  let paramsURL = { ...params }
  //Change object if make changes over params make changes in componets related   (Change URL object)



  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['scheduleMainGrid', paramsURL['mirs_competition'], paramsURL['mirs_language']],
      queryFn: getScheduleMainGrid,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //enabled: !!confCategory
      onError: (error) =>
        console.error(`Something went wrong: ${error.message}`),
    });

  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader />; }
  if (!data?.competition_schedule) { return <NotAvailable /> }

  return (<Grid data={data} paramsURL={paramsURL} />)

}

export default ScheduleGrid;


const Grid = ({ data, paramsURL }) => {


  const { breakPoint } = useViewport();

  let allDisciplines = ['CER'];
  data && data?.disciplines.filter(item => item?.isSport && item?.scheduled)?.forEach((item, index) => {
    allDisciplines.push(item.code);
  })


  data?.disciplines?.sort((a, b) => a.description - b.description).forEach((item, index) => {
    data.manualSortOrder = index
    if (item.code === "CER") { data.manualSortOrder = -1 }
  });

  data?.disciplines?.sort((a, b) => a.manualSortOrder - b.manualSortOrder);

  let allDates = [];
  let dates = groupByDate(data?.competition_schedule, 'date');
  for (const [key, value] of Object.entries(dates)) {
    allDates.push({ key })
  }
  let allDatesSort = allDates.sort((a, b) => new Date(a.key) - new Date(b.key));

  let dataTable;
  let rowDiscipline = [];
  allDisciplines?.forEach((discipline, indexDis) => {

    let rowItem = {};
    rowItem.discipline = discipline;
    let allDays = [];

    allDatesSort?.forEach((day, indexDay) => {

      let scheduleData = data?.competition_schedule.find(item => item?.discipline?.code === discipline && item?.date === day.key)
      let disciplineData = data?.disciplines.find(item => item?.code === discipline)
      let dataItem = {};

      dataItem.discipline = discipline;
      dataItem.description = disciplineData?.description;
      dataItem.disciplineOrder = indexDis;

      dataItem.date = day.key;
      dataItem.eventCount = scheduleData ? scheduleData?.eventCount : 0;
      dataItem.medalEventCount = scheduleData ? scheduleData?.medalEventCount : 0;
      dataItem.events = scheduleData?.events
      allDays.push(dataItem);
      //rowItem = rowItem + dataItem + ","
      //rowDiscipline.push(rowItem)
    })
    rowItem.data = [...allDays]
    rowDiscipline.push(rowItem);
  })
  dataTable = [...rowDiscipline];

  //{dataTable.map(item => <div>{item[0]?.description}</div>)}sss
  let cols = [];
  allDatesSort?.forEach((day, indexDay) => {
    cols.push(
      {
        id: 'fecha' + (indexDay + 1),
        Header: () => {
          paramsURL["mirs_date"] = day.key
          paramsURL["mirs_discipline"] = ''
          const url = useGetURL(paramsURL, 'schedule');
          return (
            <>
              <div>{dateFormat(day.key, undefined, 'DD')}</div>
              <div className="schedule-grid-head-day-week">{dateFormat(day.key, undefined, 'ddd')}</div>
            </>
          )
        },
        accessor: (props) => {
          let dayData = props.data.find(item => item.date === day.key)
          let evetUnitDay = dayData?.eventCount;
          let medalsDay = dayData?.medalEventCount;
          let discipline = dayData?.discipline
          let disciplineDes = dayData?.description
          let eventsToMedal = dayData?.events?.map((event, index) => (<div key={day.key + '-' + discipline + '-' + index}>{event?.description}</div>))
          let outDay;
          let date = day.key;
          paramsURL["mirs_discipline"] = discipline
          paramsURL["mirs_date"] = date //pasamos a la URL la nueva fecha del JSON 

          const url = props.discipline !== 'CER' ? getURL(paramsURL, 'schedule') : '';
          const isCeremony = props.discipline === 'CER';
          const popover = (
            <Popover id={`mirs-popover-schedule-grid-${day.key + '-' + discipline}`}>
              <Popover.Header as="div">
                <div className={`popover-discipline ${props.discipline}`}><Discipline code={props.discipline} description={disciplineDes} /></div>
                <div className="popover-date">{dateFormat(date, undefined, 'ddd, D MMM')}</div></Popover.Header>
              <Popover.Body>
                {eventsToMedal}
              </Popover.Body>
            </Popover>

          );
          if (isCeremony && evetUnitDay > 0) {
            outDay = <Link to={url}><div className="sch-CER"><img aria-hidden="true" src="/assets/images/sports/EG2023/Dark/CER_blue.png" /></div></Link>
          } else if (medalsDay > 0) {
            outDay = <Link to={url}><OverlayTrigger trigger={["hover", "hover"]} placement="auto" overlay={popover}><div className="sch-medal-day"><span>M</span></div></OverlayTrigger></Link>
          } else if (evetUnitDay > 0) {
            outDay = <Link to={url}><div className="sch-day"><span>O</span></div></Link>
          }
          return (
            <>
              {outDay}
            </>
          )
        },
        disableSortBy: true,
        className: 'schedule-grid-body-day',
        isVisible: false,
        columnIndex: indexDay + 1,
        headerClassName: 'schedule-grid-head-day'
      },
    )
  })

  let _columns = React.useMemo(
    () => [
      {
        id: 'Rank',
        Header: "Order",
        headerClassName: 'd-none',
        className: 'd-none',
        accessor: (props) => {
          let order = props.data.find(item => item.discipline === props.discipline)?.disciplineOrder;
          return (
            order
          )
        },
      },
      {
        Header: <Label data='LabelDiscipline' />,
        accessor: (props) => {
          let discipline = props.data.find(item => item.discipline === props.discipline)?.description;
          paramsURL["mirs_discipline"] = props.discipline
          paramsURL["mirs_date"] = "";
          const url = props.discipline !== 'CER' ? getURL(paramsURL, 'schedule') : '';
          return (
            <Link to={url} className={props.discipline}><Discipline code={props.discipline} description={discipline} /></Link>
          )
        },
        disableSortBy: true,
        className: 'schedule-grid-body-discipline fw-bold',
        headerClassName: 'schedule-grid-head-discipline',
        id: 'discipline'
      }, ...cols], [breakPoint]
  )

  let count = '';
  let tot = 0;
  let countAll = '';
  let totAll = 0;
  let columsAll = '0';
  let number
  let today = moment().format("YYYY-MM-DD")
  const firstDate = allDatesSort?.find(d => d !== undefined)?.key
  const lastDate = allDatesSort[allDatesSort.length -1]?.key

  if (breakPoint === "sm" || breakPoint === "xs") {
    number = '3'
  } else if (breakPoint === "xxl") {
    number = allDatesSort.length
  } else {
    number = '10'
  }


  for (var i = Number(number); i < allDatesSort.length; i = i + Number(number)) {
    countAll = countAll + number + ','
    totAll = i;

  }
  if (countAll === '') {
    columsAll = number + ",0"
  } else {
    columsAll = (countAll + (allDatesSort.length - totAll))
  }

  let nCols = columsAll;
  
  let currentDateIndex = allDatesSort.findIndex((o)=>o.key === today);
  let colIndex = (currentDateIndex === -1) ? 1 : Math.ceil((currentDateIndex+1)/number)

  return (
    <>

      <PageHeader title={<Label data="CompetitionSchedule" />} />

      <div className="schedule-grid-bgcolor">
        < MirsTable
          className='schedule-grid-wrapper'
          data={dataTable}
          columns={_columns}
          theadClassName='schedule-grid-head'
          tbodyClassName='schedule-grid-body'
          colsExtendedVisible={nCols}
          showNavExtendedData={Number(number) < allDatesSort.length}
          colIndex={colIndex}
          id={`mirs-table-schedule-grid`} />
      </div>
    </>
  );
}

